import type { WriteOk } from "@/api/admin";

/**
 * What a screen says after a save: "Saved.", or that the site is rebuilding.
 *
 * One sentence for every screen, because every save the site is built from
 * goes live the same way (`worker/src/domain/site-rebuild.ts`).
 */
export function savedNotice(answer: WriteOk, verb = "Saved"): string {
  return answer.published === true
    ? `${verb}. The site is rebuilding -- the change shows in a few minutes.`
    : `${verb}.`;
}
